import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const COPY = {
  denied: {
    eyebrow: 'Access restricted',
    title: 'You do not have access to this area',
    description: 'Your account is signed in, but it is missing the permission required for this page. Ask an administrator if you need access.'
  },
  'not-found': {
    eyebrow: 'Page not found',
    title: 'We could not find that page',
    description: 'The address may be outdated or mistyped. Use the navigation to continue, or return to Home.'
  }
};

const RouteRecovery = ({ variant = 'not-found' }) => {
  const copy = COPY[variant];

  return (
    <section
      aria-labelledby={`route-recovery-${variant}-title`}
      className="min-h-full flex items-center justify-center px-6 py-16"
    >
      <div className="w-full max-w-xl border border-glass-border bg-surface-1 p-6 sm:p-8">
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.16em] text-accent">
          {copy.eyebrow}
        </p>
        <h1
          id={`route-recovery-${variant}-title`}
          className="text-2xl font-semibold text-text-primary sm:text-3xl"
        >
          {copy.title}
        </h1>
        <p className="mt-3 max-w-lg text-sm leading-6 text-text-secondary">
          {copy.description}
        </p>
        <Link
          to="/"
          className="mt-7 inline-flex min-h-11 items-center justify-center bg-accent px-5 py-2.5 text-sm font-semibold text-black focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-surface-1"
        >
          Return to Home
        </Link>
      </div>
    </section>
  );
};

RouteRecovery.propTypes = {
  variant: PropTypes.oneOf(['denied', 'not-found'])
};

export default RouteRecovery;
